import { useContext } from "react";
import { GlobalStateContext } from "@utils/GlobalContext";

function Loader() {
  const { loading } = useContext(GlobalStateContext);
  const loadingMessage = loading.message ? loading.message : "Caricamento...";
  const loadingDuration = loading.duration ? loading.duration : 1000; 


  

  return (
    <>
      {loading.isLoading && (
        <div className="page-loader-wrapper">
          <div className="cube-container fix" id="loader">
            <div className="logo-small logo-rotondo">
              <div className="glow"></div>
              <div className="counter-glow"></div>
              <div className="third-glow"></div>
            </div>
            <br />
            <br />
            <div className="message">{loadingMessage}</div>
            <br />
            <div
              className="progress"
              style={{
                "--progress-animation-duration": `${loadingDuration}ms`, 
              }}
            >
              <div
                className="progress-bar progress-bar-striped progress-bar-animated"
                // style={{ width: progress + "%" }}
              ></div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Loader;